<script>
    import { createEventDispatcher } from 'svelte';
    import { network } from '../stores.js';

    const dispatch = createEventDispatcher();

    let step = 1;
    let innQuery = '';
    let innError = '';
    let lookupLoading = false;
    let saveLoading = false;
    let saveError = '';

    let form = {
        name: '',
        nameKrat: '',
        inn: '',
        kpp: '',
        ogrn: '',
        orgforma: '',
        urAdres: '',
        telefon: '',
        eMail: '',
        kontaktLico: '',
    };

    function escape(v) {
        return (v ?? '').replace(/'/g, "''");
    }

    function resetForm() {
        form = {
            name: '',
            nameKrat: '',
            inn: '',
            kpp: '',
            ogrn: '',
            orgforma: '',
            urAdres: '',
            telefon: '',
            eMail: '',
            kontaktLico: '',
        };
        innQuery = '';
        innError = '';
        saveError = '';
        step = 1;
    }

    function close() {
        resetForm();
        dispatch('close');
    }

    async function lookupInn() {
        innError = '';
        const inn = innQuery.replace(/\D/g, '');
        if (!/^\d{10}$|^\d{12}$/.test(inn)) {
            innError = 'ИНН должен содержать 10 или 12 цифр';
            return;
        }

        lookupLoading = true;
        try {
            const resp = await fetch('https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/party', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Token a3c7b320bb4567ef00bbb6796b4840280b55a017',
                },
                body: JSON.stringify({ query: inn }),
            });
            const data = await resp.json();
            if (data.suggestions?.length) {
                const s = data.suggestions[0].data;
                form.name = s.name?.short_with_opf ?? '';
                form.nameKrat = s.name?.full_with_opf ?? '';
                form.urAdres = s.address?.value ?? '';
                form.inn = s.inn ?? inn;
                form.kpp = s.kpp ?? '';
                form.ogrn = s.ogrn ?? '';
                form.orgforma = s.opf?.full ?? '';
                step = 2;
            } else {
                innError = 'Организация с таким ИНН не найдена';
            }
        } catch (e) {
            innError = 'Ошибка при поиске по ИНН';
        } finally {
            lookupLoading = false;
        }
    }

    function goToManual() {
        form.inn = innQuery.replace(/\D/g, '');
        step = 2;
    }

    async function saveClient() {
        saveError = '';
        if (!form.name?.trim()) {
            saveError = 'Укажите краткое название';
            return;
        }

        saveLoading = true;
        try {
            console.log('[saveClient] starting, form:', JSON.stringify(form));

            const sql = `
                EXEC addUrlica
                    @name = N'${escape(form.name)}',
                    @nameKrat = N'${escape(form.nameKrat)}',
                    @inform = N'',
                    @urAdres = N'${escape(form.urAdres)}',
                    @factAdres = N'',
                    @inn = N'${escape(form.inn)}',
                    @kpp = N'${escape(form.kpp)}',
                    @ogrn = N'${escape(form.ogrn)}',
                    @orgforma = N'${escape(form.orgforma)}',
                    @direktor = N'',
                    @glavBuh = N'',
                    @telefon = N'${escape(form.telefon)}',
                    @eMail = N'${escape(form.eMail)}',
                    @kontaktLico = N'${escape(form.kontaktLico)}',
                    @inform1 = N'',
                    @svoi = 0,
                    @actualnost = 1,
                    @shemaProdaj = 0,
                    @summa = 0,
                    @procent = 0,
                    @vid = 2,
                    @sub  = 0,
                    @idUrllicoPar  = -1
                    ,@project= N''
                    ,@scanDogovor = N''
                    ,@shablonDogovor = N''
                     ,@nomerDog = N''
                     ,@dateDog = N''
                        `;

            const rawResult = await network.proxy(sql, false);
            const result = Array.isArray(rawResult) ? rawResult : rawResult;
            const id = result[0]?.idUrllico ?? result?.idUrllico;


            if (!id) {
                saveError = `Клиент сохранён, но не удалось получить ID. Raw: ${JSON.stringify(rawResult)}`;
                return;
            }

            dispatch('created', { id: +id, name: form.name.trim() });
            resetForm();
        } catch (e) {
            console.error('[saveClient] ERROR:', e);
            saveError = 'Ошибка: ' + e.message;
        } finally {
            saveLoading = false;
        }
    }
</script>

<div class="modal-backdrop fade show" on:click={close}></div>
<div class="modal fade show new-client-modal" style="display: block;" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Новый клиент</h5>
                <button type="button" class="btn-close" aria-label="Закрыть" on:click={close}></button>
            </div>

            <div class="modal-body">
                {#if step === 1}
                    <div class="form-group boxed">
                        <label class="form-label" for="inn-lookup">ИНН</label>
                        <input
                            id="inn-lookup"
                            type="text"
                            class="form-control"
                            placeholder="10 или 12 цифр"
                            bind:value={innQuery}
                            maxlength="12"
                            inputmode="numeric"
                        />
                        {#if innError}
                            <div class="field-error">{innError}</div>
                        {/if}
                    </div>
                    <div class="modal-actions">
                        <button
                            type="button"
                            class="btn btn-primary"
                            on:click={lookupInn}
                            disabled={lookupLoading}
                        >
                            {lookupLoading ? 'Поиск...' : 'Найти по ИНН'}
                        </button>
                        <button type="button" class="btn btn-link btn-sm" on:click={goToManual}>
                            Заполнить вручную
                        </button>
                    </div>
                {:else}
                    <div class="form-group boxed">
                        <label class="form-label" for="client-name">Название (краткое) *</label>
                        <input id="client-name" type="text" class="form-control" bind:value={form.name} maxlength="255" />
                    </div>
                    <div class="form-group boxed">
                        <label class="form-label" for="client-nameKrat">Официальное название</label>
                        <input id="client-nameKrat" type="text" class="form-control" bind:value={form.nameKrat} maxlength="255" />
                    </div>
                    <div class="form-row">
                        <div class="form-group boxed">
                            <label class="form-label" for="client-inn">ИНН</label>
                            <input id="client-inn" type="text" class="form-control" bind:value={form.inn} maxlength="12" />
                        </div>
                        <div class="form-group boxed">
                            <label class="form-label" for="client-kpp">КПП</label>
                            <input id="client-kpp" type="text" class="form-control" bind:value={form.kpp} maxlength="255" />
                        </div>
                    </div>
                    <div class="form-group boxed">
                        <label class="form-label" for="client-ogrn">ОГРН</label>
                        <input id="client-ogrn" type="text" class="form-control" bind:value={form.ogrn} maxlength="255" />
                    </div>
                    <div class="form-group boxed">
                        <label class="form-label" for="client-urAdres">Юр. адрес</label>
                        <input id="client-urAdres" type="text" class="form-control" bind:value={form.urAdres} maxlength="255" />
                    </div>
                    <div class="form-row">
                        <div class="form-group boxed">
                            <label class="form-label" for="client-telefon">Телефон</label>
                            <input id="client-telefon" type="text" class="form-control" bind:value={form.telefon} maxlength="255" />
                        </div>
                        <div class="form-group boxed">
                            <label class="form-label" for="client-email">Email</label>
                            <input id="client-email" type="email" class="form-control" bind:value={form.eMail} maxlength="255" />
                        </div>
                    </div>
                    <div class="form-group boxed">
                        <label class="form-label" for="client-kontakt">Контактное лицо</label>
                        <input id="client-kontakt" type="text" class="form-control" bind:value={form.kontaktLico} maxlength="255" />
                    </div>
                    {#if saveError}
                        <div class="field-error">{saveError}</div>
                    {/if}
                {/if}
            </div>

            {#if step === 2}
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" on:click={close} disabled={saveLoading}>
                        Отмена
                    </button>
                    <button type="button" class="btn btn-primary" on:click={saveClient} disabled={saveLoading}>
                        {saveLoading ? 'Сохранение...' : 'Сохранить'}
                    </button>
                </div>
            {/if}
        </div>
    </div>
</div>

<style>
    .new-client-modal { z-index: 1055; }
    .modal-backdrop { z-index: 1050; }
    .form-label { font-size: 12px; font-weight: 600; color: #6b7280; margin-bottom: 6px; display: block; }
    .form-control { border-radius: 12px; border: 1px solid #d8dde3; min-height: 44px; width: 100%; }
    .form-group { margin-bottom: 12px; }
    .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
    .field-error { margin-top: 6px; font-size: 12px; color: #c62828; }
    .modal-actions { display: flex; flex-direction: column; align-items: stretch; gap: 8px; }
    .modal-footer { display: flex; justify-content: flex-end; gap: 8px; }
    @media (max-width: 480px) {
        .form-row { grid-template-columns: 1fr; }
    }
</style>
